import { create as createActiveQuotePageComponent } from "~/pages/ActiveQuotePage/ActiveQuotePage";
import { createCheckoutPage as createCheckoutDisplayComponent } from "~/pages/CheckoutPage/CheckoutPage";
import { createOrderConfirmationPage } from "~/features/cart/cart/jspComponents/OrderConfirmationPageComponent";
import { createQuoteConfirmationPage } from "~/features/cart/cart/jspComponents/QuoteConfirmationPageComponent";
import { create as createConfirmationModalComponent } from "~/bridges/ConfirmationModalComponent";
import { create as createNavigation } from "~/bridges/header/Navigation";
import { createOrderDetailsPage } from "~/features/orders/orderDetails/OrderDetailsPage";
import { create as createOrderHistoryDisplayComponent } from "~/features/orders/orderList/OrderListPageComponent";
import { createProductDetailsPage } from "~/pages/ProductDetailsPage/ProductDetailsPage";
import { create as createToastMessage } from "~/bridges/ToastMessageComponent";
import { create as createPrimaryLinkButtonComponent } from "~/bridges/PrimaryLinkButtonComponent";
import { createHeaderNavigation } from "~/bridges/header/HeaderNavigationComponent";
import { createBearingFrequencyCalculatorPage } from "~/pages/BearingFrequencyCalculatorPage/BearingFrequencyCalculatorPage";

import { createChangePasswordPage } from "~/pages/ChangePasswordPage/ChangePasswordPage";

import { create as createButton } from "~/bridges/Button";

import { registerComponentFactory } from "./utils/componentRegistry";
import { createOrderbookPage } from "~/pages/OrderbookPage/OrderbookPage";
import { createAccountSelectionPageComponent } from "~/pages/AccountSelectionPage/AccountSelectionPage";
import { createContactUsPage } from "~/pages/ContactUsPage/ContactUsPage";
import { createContactUsConfirmationPage } from "~/pages/ContactUsConfirmationPage/ContactUsConfirmationPage";
import { createSavedConfigurationsPage } from "~/pages/SavedConfigurationsPage/SavedConfigurationsPage";
import { createNavigationBreadcrumbs } from "./bridges/createNavigationBreadcrumbs";
import { InquirySuccessPage } from "~/features/inquirySuccess/components/InquirySuccessPage";
import { createMyAccountPage } from "~/pages/MyAccountPage/MyAccountPage";
import { createLinearRequestQuoteSuccessPage } from "~/features/configurator/Linear/components/LinearRequestQuoteSuccessPage";
import { createSelectionAssistant } from "~/pages/BearingSelectionAssistantPage/BearingSelectionAssistantPage";
import { createHousingSelectionAssistant } from "~/pages/HousingSelectionAssistantPage/HousingSelectionAssistantPage";
import { createSTCfinderPage } from "~/pages/StcFinderPage/StcFinderPage";
import { createRegisterFreeSuccessPage } from "~/pages/RegisterFreeSuccessPage/RegisterFreeSuccessPage";
import { createCMSComponent } from "~/bridges/createCMSComponent";
import { createAffiliateSalesPartnerBanner } from "~/features/affiliate/components/AffiliateSalesPartnerBanner/AffiliateSalesPartnerBanner";
import { createAffiliateSalesPartnerPopup } from "~/features/affiliate/components/AffiliateSalesPartnerPopup/AffiliateSalesPartnerPopup";
import { createAccountSettings } from "~/pages/AccountSettingsPage/AccountSettingsPage";
import { createOrderQuoteNotificationsPage } from "~/pages/OrderQuoteNotificationsPage/OrderQuoteNotificationsPage";
import { createBrowserNotSupportedPopup } from "~/bridges/createBrowserNotSupportedPopup";
import { createRegionSelectionBanner } from "~/bridges/createRegionSelectionBanner";
import { createModalServiceRoot } from "~/common/utils/ModalService";
import { NotificationsPage } from "~/features/notifications/NotificationsPage/NotificationsPage";
import { createNotificationSettingsPage } from "~/features/notifications/NotificationSettingsPage/NotificationSettingsPage";
import { createBottomNavigation } from "~/features/BottomNavigation/BottomNavigation";
import { createRecentlyViewedProductsComponent } from "~/features/RecentlyViewedProducts/RecentlyViewedProducts";
import { createHeaterSelectionAssistantComponent } from "~/pages/HeaterSelectionAssistantPage/HeaterSelectionAssistantPage";
import { createSchaefflerCADFileSearchComponent } from "~/features/CADSearch/SchaefflerCADFileSearchComponent";
import { createScanDMCPage } from "~/pages/ScanDmcPage/ScanDmcPage";
import { createProductListPage } from "~/pages/ProductListPage/ProductListPage";
import { createSearchPage } from "~/pages/SearchPage/SearchPage";
import { createPageFooter } from "~/common/components/PageFooter/PageFooter";
import { createSalesCampaignPage } from "~/pages/SalesCampaignPage/SalesCampaignPage";
import { createWishlistPage } from "~/pages/WishlistPage/WishlistPage";
import { createCartPage } from "~/pages/CartPage/CartPage";
import { createB2CRequestPage } from "~/pages/B2CRequestPage/B2CRequestPage";
import { createSchaefflerTopBannerComponent } from "~/features/cms/components/schaefflerTopBanner/SchaefflerTopBannerComponent";
import { createQuoteDetailsPage } from "~/features/orders/quoteDetails/components/v2/QuoteDetailsPage";
import { createQuoteListPage as createQuoteListDisplayComponent } from "~/features/orders/quoteList/QuoteListPage";
import { FreeCapacityCockpitPage } from "~/features/freeCapacityPush/FreeCapacityPushPage";
import { creatContractDetailsPage as createContractDetailsPageComponent } from "~/pages/ContractDetailsPage/ContractDetailsPage";
import { createRequestContractPage as createContractPageComponent } from "~/pages/RequestContractPage/RequestContractPage";
import { createDataSheetPage } from "~/pages/DataSheetPage/DataSheetPage";
import { LubricationSelectionAssistantPage } from "~/pages/LubricationSelectionAssistantPage/LubricationSelectionAssistantPage";
import { RegisterForFreePage } from "~/pages/RegisterForFreePage/RegisterForFreePage";
import { createCustomerRegistrationPage } from "~/features/registration/components/CustomerRegistrationPage/CustomerRegistrationPage";
import { createSchaefflerFccRecommendationComponent } from "~/features/saleRecommendations/components/SchaefflerFCCGapProductsRecommendationComponent";
import { createMediaLibraryPage } from "~/features/mediaLibrary/components/MediaLibraryPage";
import { createManageUsersPage as createUserAccountsComponent } from "~/pages/ManageUserAccountsPage/ManageUserAccountsPage";
import { createStorefrontShell } from "~/app/shell/StorefrontShell";
import type { AppDispatch } from "~/app/store";
import { clearOccToken } from "~/app/api/occ/occToken";

export const registerComponents = (dispatch: AppDispatch) => {
  registerComponentFactory("AccountSelectionPageComponent", createAccountSelectionPageComponent);
  registerComponentFactory("ActiveQuotePageComponent", createActiveQuotePageComponent);
  registerComponentFactory("CartDisplayComponent", createCartPage);
  registerComponentFactory("CheckoutDisplayComponent", createCheckoutDisplayComponent);
  registerComponentFactory("OrderConfirmationPageComponent", createOrderConfirmationPage);
  registerComponentFactory("QuoteConfirmationPageComponent", createQuoteConfirmationPage);
  registerComponentFactory("ConfirmationModalComponent", createConfirmationModalComponent);
  registerComponentFactory("ContactUsDisplayComponent", createContactUsPage);
  registerComponentFactory("ContactUsConfirmationComponent", createContactUsConfirmationPage);
  registerComponentFactory("Navigation", (props) => createNavigation(props, dispatch));
  registerComponentFactory("OrderDetailsDisplayComponent", createOrderDetailsPage);
  registerComponentFactory("OrderHistoryDisplayComponent", createOrderHistoryDisplayComponent);
  registerComponentFactory("QuoteDetailsDisplayComponent", createQuoteDetailsPage);
  registerComponentFactory("QuoteListDisplayComponent", createQuoteListDisplayComponent);

  registerComponentFactory("WishlistPageComponent", createWishlistPage);
  registerComponentFactory("lsaPage", () => <LubricationSelectionAssistantPage />);

  registerComponentFactory("BearingFrequencyCalculatorComponent", createBearingFrequencyCalculatorPage);
  registerComponentFactory("NotificationsPageComponent", () => <NotificationsPage />);
  registerComponentFactory("NotificationSettingsPageComponent", createNotificationSettingsPage);

  registerComponentFactory("ContractDetailsPageComponent", createContractDetailsPageComponent);
  registerComponentFactory("CreateContractPageComponent", createContractPageComponent);
  registerComponentFactory("ProductDetailsPage", createProductDetailsPage);
  registerComponentFactory("ToastMessage", createToastMessage);
  registerComponentFactory("PrimaryLinkButtonComponent", createPrimaryLinkButtonComponent);
  registerComponentFactory("HeaderNavigation", (props) => createHeaderNavigation(props, clearOccToken));
  registerComponentFactory("StorefrontShell", createStorefrontShell);
  registerComponentFactory("UserAccountsComponent", createUserAccountsComponent);

  registerComponentFactory("ChangePasswordPage", createChangePasswordPage);

  registerComponentFactory("Button", createButton);

  registerComponentFactory("SelectionAssistantPage", createSelectionAssistant);
  registerComponentFactory("HousingSelectionAssistantPage", createHousingSelectionAssistant);

  registerComponentFactory("ABMonitorPage", createOrderbookPage);
  registerComponentFactory("SavedConfigurationsPage", createSavedConfigurationsPage);
  registerComponentFactory("Breadcrumbs", createNavigationBreadcrumbs);

  registerComponentFactory("PublicRegistrationPage", (props) => <RegisterForFreePage {...props} />);
  registerComponentFactory("SelfRegistrationPage", createCustomerRegistrationPage);
  registerComponentFactory("ConfirmationPage", createRegisterFreeSuccessPage);

  registerComponentFactory("SalesPartnerWishlistConfirmationPage", (props) => <InquirySuccessPage {...props} />);
  registerComponentFactory("MediaLibrary", createMediaLibraryPage);
  registerComponentFactory("STCfinderPageComponent", createSTCfinderPage);
  registerComponentFactory("MyAccountPage", createMyAccountPage);
  registerComponentFactory("AccountSettingsPage", createAccountSettings);
  registerComponentFactory("OrderQuoteSettingsPage", createOrderQuoteNotificationsPage);

  registerComponentFactory("LinearRequestQuoteSuccessPage", createLinearRequestQuoteSuccessPage);

  registerComponentFactory("AffiliateSalesPartnerPopup", createAffiliateSalesPartnerPopup);
  registerComponentFactory("AffiliateSalesPartnerBanner", createAffiliateSalesPartnerBanner);

  registerComponentFactory("BrowserNotSupportedPopup", createBrowserNotSupportedPopup);

  registerComponentFactory("RegionSelectionBanner", createRegionSelectionBanner);

  registerComponentFactory("BottomNavigationComponent", createBottomNavigation);

  registerComponentFactory("B2CRequestPage", createB2CRequestPage);

  // CMS Components
  registerComponentFactory("CMSComponent", createCMSComponent);
  registerComponentFactory("CMSColumnLinks", createCMSComponent);
  registerComponentFactory("CMSAccordionContainer", createCMSComponent);
  registerComponentFactory("CMSAccordion", createCMSComponent);
  registerComponentFactory("CMSTable", createCMSComponent);
  registerComponentFactory("CMSHomepagePersonalization", createCMSComponent);
  registerComponentFactory("CMSChipLink", createCMSComponent);

  registerComponentFactory("ModalServiceRoot", createModalServiceRoot);

  registerComponentFactory("RecentlyViewedProductsComponent", createRecentlyViewedProductsComponent);

  registerComponentFactory("HeaterSelectionAssistant", createHeaterSelectionAssistantComponent);

  registerComponentFactory("SchaefflerCADFileSearchComponent", createSchaefflerCADFileSearchComponent);
  registerComponentFactory("ScanDMCPage", createScanDMCPage);
  registerComponentFactory("FooterNavigation", createPageFooter);

  registerComponentFactory("SearchPage", createSearchPage);
  registerComponentFactory("ProductListPage", createProductListPage);
  registerComponentFactory("SalesCampaignPage", createSalesCampaignPage);

  registerComponentFactory("SchaefflerTopBannerComponent", createSchaefflerTopBannerComponent);

  registerComponentFactory("FreeCapacityPush", () => <FreeCapacityCockpitPage />);
  registerComponentFactory("AffiliateDownloadDatasheetPage", createDataSheetPage);
  registerComponentFactory(
    "SchaefflerFCCGapProductsRecommendationComponent",
    createSchaefflerFccRecommendationComponent,
  );
  registerComponentFactory("CMSPhotoGallery", createCMSComponent);
  registerComponentFactory("CMSPhoto", createCMSComponent);
  registerComponentFactory("CMSKameleoonSlot", createCMSComponent);
};
